import { DocumentNode } from '@apollo/client/core';
import { Kind } from 'graphql/language';
import { FragmentDefinitionNode } from 'graphql/language/ast';

export function removeDuplicateFragmentsLogic(doc: DocumentNode) {
    const usedFragments: Record<string, boolean> = {};

    return {
        ...doc,
        definitions: doc.definitions.filter((def) => {
            const included = def.kind !== Kind.FRAGMENT_DEFINITION || !usedFragments[def.name.value];
            if (included) {
                usedFragments[(def as FragmentDefinitionNode).name.value] = true;
            }
            return included;
        }),
    };
}
